module.exports = __webpack_public_path__ + "static/media/img-feature-match-200@2x.42971888.png";